import i18next from "i18next";

const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP;
const whatsappLink = () => {
	const whatsappMessage =
		i18next.t("blog.contactSection.whatsappMessage") ||
		"Eu preciso de suporte da Verzel!";
	const message = encodeURIComponent(whatsappMessage);
	return `https://wa.me/${whatsappNumber}?text=${message}`;
};

export const socialNetworks = {
	linkedin: "https://www.linkedin.com/company/verzeloficial/",
	instagram: "https://www.instagram.com/verzel.tech/",
	whatsapp: whatsappLink,
	x: "#",
};

export const utilityLinks = {
	workWithUs:
		"https://painel.umentor.com.br/inteligente_novos/?con_cod=por467117&pla=5",
};

export const phoneNumbers = {
	"rj-sp": "0800 558 0066",
	"br": "+55 11 93292-3563",
	"de-berlim": "+49 1512 8787315",
	"pt-lisboa": "+55800 558 0066",
};
